export default {"src":"/pro/_next/static/media/lit.0e89e4d7.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};